import * as React from 'react';
import './EstimatedScore.css';

interface Props {
    stage: string;
    type: string;
}

class EstimatedScore extends React.Component<Props> {
    render() {
        const { stage, type } = this.props;

        return (
            <div className="flex-item estimated-score-wrapper">
                <h1 className="estimated-score-label">Analytics Maturity Score</h1>
                <div className="estimated-score-box">
                    <h1 className="estimated-score-stage">
                        {stage}
                    </h1>
                    <p className="estimated-score-type">
                        {type}
                    </p>
                </div>
            </div>
        );
    }
}

export default EstimatedScore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/EstimatedScore.tsx